const HomeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M11.8225 1.65208C12.1974 1.43783 12.6577 1.43783 13.0326 1.65208L15.1668 2.87164C15.7516 3.20582 15.9548 3.95079 15.6206 4.5356C15.2865 5.1204 14.5415 5.32357 13.9567 4.9894L12.4275 4.11559L10.8984 4.9894C10.3136 5.32357 9.56859 5.1204 9.23442 4.5356C8.90024 3.95079 9.10342 3.20582 9.68822 2.87164L11.8225 1.65208Z"
      fill="white"
    />
    <path
      d="M7.0837 5.76458C7.41787 6.34938 7.2147 7.09436 6.62989 7.42853L6.34869 7.58921L6.62989 7.7499C7.2147 8.08407 7.41787 8.82905 7.0837 9.41385C6.74953 9.99865 6.00455 10.2018 5.41975 9.86766L5.11015 9.69074V10.0283C5.11015 10.7019 4.56413 11.2479 3.89058 11.2479C3.21704 11.2479 2.67102 10.7019 2.67102 10.0283V7.58921C2.67102 7.28434 2.78289 7.0056 2.96782 6.79179C3.01008 6.74287 3.05637 6.69715 3.10639 6.65517C3.16804 6.60335 3.2349 6.55753 3.30606 6.51859L5.41975 5.31077C6.00455 4.9766 6.74953 5.17977 7.0837 5.76458Z"
      fill="white"
    />
    <path
      d="M17.7714 5.76458C18.1055 5.17977 18.8505 4.9766 19.4353 5.31077L21.549 6.51858C21.6202 6.55752 21.687 6.60335 21.7487 6.65517C22.0149 6.87888 22.184 7.21429 22.184 7.58921V10.0283C22.184 10.7019 21.638 11.2479 20.9645 11.2479C20.2909 11.2479 19.7449 10.7019 19.7449 10.0283V9.69074L19.4353 9.86766C18.8505 10.2018 18.1055 9.99865 17.7714 9.41385C17.4372 8.82905 17.6404 8.08407 18.2252 7.7499L18.5064 7.58921L18.2252 7.42853C17.6404 7.09436 17.4372 6.34938 17.7714 5.76458Z"
      fill="white"
    />
    <path
      d="M9.23442 10.6428C9.56859 10.058 10.3136 9.85486 10.8984 10.189L12.4275 11.0628L13.9567 10.189C14.5415 9.85486 15.2865 10.058 15.6206 10.6428C15.9548 11.2276 15.7516 11.9726 15.1668 12.3068L13.6471 13.1752V14.9066C13.6471 15.5801 13.1011 16.1262 12.4275 16.1262C11.754 16.1262 11.208 15.5801 11.208 14.9066V13.1752L9.68822 12.3068C9.10342 11.9726 8.90024 11.2276 9.23442 10.6428Z"
      fill="white"
    />
    <path
      d="M3.89058 13.687C4.56413 13.687 5.11015 14.2331 5.11015 14.9066V16.638L6.62989 17.5064C7.2147 17.8406 7.41787 18.5856 7.0837 19.1704C6.74953 19.7552 6.00455 19.9583 5.41975 19.6242L3.28551 18.4046C2.90553 18.1875 2.67102 17.7834 2.67102 17.3457V14.9066C2.67102 14.2331 3.21704 13.687 3.89058 13.687Z"
      fill="white"
    />
    <path
      d="M20.9645 13.687C21.638 13.687 22.184 14.2331 22.184 14.9066V17.3457C22.184 17.7834 21.9495 18.1875 21.5696 18.4046L19.4353 19.6242C18.8505 19.9583 18.1055 19.7552 17.7714 19.1704C17.4372 18.5856 17.6404 17.8406 18.2252 17.5064L19.7449 16.638V14.9066C19.7449 14.2331 20.2909 13.687 20.9645 13.687Z"
      fill="white"
    />
    <path
      d="M9.23442 20.3993C9.56859 19.8145 10.3136 19.6114 10.8984 19.9455L11.208 20.1225V19.7849C11.208 19.1113 11.754 18.5653 12.4275 18.5653C13.1011 18.5653 13.6471 19.1113 13.6471 19.7849V20.1225L13.9567 19.9455C14.5415 19.6114 15.2865 19.8145 15.6206 20.3993C15.9548 20.9841 15.7516 21.7291 15.1668 22.0633L13.0511 23.2723C12.8687 23.3811 12.6554 23.4435 12.4275 23.4435C12.1997 23.4435 11.9864 23.3811 11.8039 23.2723L9.68822 22.0633C9.10342 21.7291 8.90024 20.9841 9.23442 20.3993Z"
      fill="white"
    />
  </svg>
);

export default HomeIcon;
